import React from 'react';
import { IProps } from './types';
import OTPVerificationForm from 'components/OTPVerificationForm';

/** OTP驗證頁 */
const OTPVerification:React.FC<IProps> = (props) => {
  return <OTPVerificationForm
    memberId={props.memberId}
    otpInfo={props.otpInfo}
    getOTPTime={props.getOTPTime}
    UICode={props.UICode}
    onUnavailableAuth={props.onFetchSecque}
    onGoBack={props.onGoBack}
    onSubmit={props.onVerifyOTP}
    onResentOTP={props.onResentOTP}
  // eslint-disable-next-line react/jsx-closing-bracket-location
  />;
};

export default OTPVerification;
